import React, { Component } from 'react';
/** PERSONAL */
import Stem from '../../../NormalStem';
import Footer from '../../../Footer';
import { reverseParseTextView } from '../../../fillin/createRender';
import { STAGE_TAG } from '../../../../../../utils/questionManageType';

const $ = require('$');
const MathQuill = require('MathQuill');
const MQ = MathQuill.getInterface(2);

class Question extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            answerOr: false,
            data: reverseParseTextView(props.obj)
        };
    }

    componentDidMount() {
        this.MQload();
    }

    componentDidUpdate() {
        this.MQload();
    }

    MQload = () => {
        $('.mathquill-embedded-latex', this.viewer).removeAttr('style').each(function (index, item) {
            MQ.StaticMath(item);
        });
    };

    toggleAnswer = (val, e, answer) => {
        e.stopPropagation();
        this.setState({ visible: val });

        $('.mq-editable-field', this.viewer).each((index, item) => {
            $(item).css('fontSize', val ? 'inherit' : '0');
        });

        let answerOr = false
        $('.fillin-express', this.viewer).each((index, item) => {
            const id = $(item).attr('data-id');
            if (answer[id].split('|').length > 1) {
                answerOr = true;
            }
            $(item).text(val ? answer[id].split('|')[0] : '');
        });

        this.setState({ answerOr });
    };

    render() {
        const { visible, data } = this.state;
        const { stem, answer, answerMap } = data;
        const { stage } = this.props;

        return (
            <div className="question-wrapper" ref={el => this.viewer = el}>
                <div className="question-content">
                    <div className="question-order">
                        <p className="math_text step-tag"><span style={{ color: '#ffffff' }}>{STAGE_TAG[stage]}</span></p>
                    </div>
                    <div className="question-stem">
                        <Stem stem={stem} answerMap={answerMap} />
                    </div>
                </div>
                <div className="question-footer">
                    {
                        visible ?
                            <div className="footer-hide relative">
                                <div className="inline-block"><span>正确答案：</span></div>
                                <div className="inline-block">
                                    {
                                        answer.map((item, i) =>
                                            <span className="answer" key={i}>{item.content}</span>
                                        )
                                    }
                                </div>
                            </div> : null
                    }
                    <div className="footer-show">
                        <Footer {...this.props}>
                            <span
                                className="question-btn"
                                onClick={(e) => this.toggleAnswer(!visible, e)}>
                                {!visible ? '显示答案' : '隐藏答案'}
                            </span>
                        </Footer>
                    </div>
                </div>
            </div>
        )
    }
}


export default Question;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/step/sub-question/fillin/view.js